import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import once from 'lodash/once';

export type Weight = 'solid' | 'regular' | 'light' | 'duotone';

interface Props {
    weight?: Weight;
    icon?: string;
    className?: string;
    xs?: boolean;
    x2?: boolean;
    x3?: boolean;
    x5?: boolean;
    x7?: boolean;
    x9?: boolean;
    large?: boolean;
    spin?: boolean;
    pulse?: boolean;
    fixed?: boolean;
    color?: string;

    [key: string]: any;
}

export const loadFontAwesome = once(() => {
    const scriptElement = document.createElement('script');
    scriptElement.src = 'https://kit.fontawesome.com/78d63da542.js';
    scriptElement.crossOrigin = 'anonymous';

    // const linkElement = document.createElement('link');
    // linkElement.rel = 'stylesheet';
    // linkElement.href = 'https://pro.fontawesome.com/releases/v5.11.2/css/all.css';
    // linkElement.integrity =
    //     'sha384-XxNLWSzCxOe/CFcHcAiJAZ7LarLmw3f4975gOO6QkxvULbGGNDoSOTzItGUG++Q+';
    // linkElement.crossOrigin = 'anonymous';

    document.head.appendChild(scriptElement);
});

const FontAwesome: FC<Props> = ({
    icon,
    weight = 'solid',
    className,
    xs,
    x2,
    x3,
    x5,
    x7,
    x9,
    large,
    spin,
    pulse,
    fixed,
    color,
    ...props
}) => {
    useEffect(() => {
        loadFontAwesome();
    }, []);

    return (
        <>
            <i
                className={classNames(
                    `fa${weight[0]}`,
                    `fa-${icon}`,
                    {
                        'fa-xs': xs,
                        'fa-2x': x2,
                        'fa-3x': x3,
                        'fa-5x': x5,
                        'fa-7x': x7,
                        'fa-9x': x9,
                        'fa-pulse': pulse,
                        'fa-lg': large,
                        'fa-spin': spin,
                        'fa-fw': fixed
                    },
                    className
                )}
                style={{
                    color
                }}
                {...props}
            />
        </>
    );
};

export default FontAwesome;
